import { render, staticRenderFns } from "./AtomLinkButton.vue?vue&type=template&id=03cf69e4&scoped=true"
import script from "./AtomLinkButton.vue?vue&type=script&lang=ts"
export * from "./AtomLinkButton.vue?vue&type=script&lang=ts"
import style0 from "./AtomLinkButton.vue?vue&type=style&index=0&id=03cf69e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cf69e4",
  null
  
)

export default component.exports